export { ParagraphSizeEnum as ParagraphSizeEnum } from "./ParagraphSizeEnum";
export { default as Text } from "./Text";
export { default as EditorialParagraph } from "./EditorialParagraph";
export { default as TechnicalParagraph } from "./TechnicalParagraph";
export { default as Paragraph } from "./Paragraph";
export { default as Label1 } from "./Label1";
export { default as Label2 } from "./Label2";
export { default as Label3 } from "./Label3";
export { default as Deck } from "./Deck";
//# sourceMappingURL=index.js.map